import React, { useEffect } from "react";
import "./style.scss";
import Storelist from "../../Store/Actions";
import { Modal, Dropdown, Space, Avatar } from "antd";
import { Select } from "antd";
import { CloseOutlined, UserOutlined } from "@ant-design/icons";
import Api from "../../Utils/Api";
import { toast } from "react-toastify";
import { format } from "date-fns";

const { Option } = Select;

const AssignTechnicianModal = () => {
  const {
    PageStore,
    AssignTechnician,
    ServiceDetailsStore,
    CreateRequestDetailsStore,
    setAvailableTechnicianData_,
    setCreateRequestData_,
    RequestUserStore,
  } = Storelist();

  const serviceDetail = ServiceDetailsStore?.data;
  const { AssignTechncianToService } = Api();

  function closeModal() {
    AssignTechnician(false);
    setAvailableTechnicianData_(null);
    setCreateRequestData_({ key: "technician", value: null });
    setCreateRequestData_({ key: "pickupPerson", value: null });
    setCreateRequestData_({ key: "dropPerson", value: null });
  }

  const submitHandler = () => {
    let reqData = {};
    reqData.serviceId = serviceDetail?.bikeRequest?._id;

    // if (!RequestUserStore.technician) {
    //   toast.warn("Please select Technician", { position: "top-center" });
    //   return;
    // }

    reqData.serviceTechnician = RequestUserStore.technician
      ? RequestUserStore.technician
      : null;

    // if (serviceDetail?.bikeRequest?.serviceType?.serviceTypeCode === "PUMB") {
    //   if (!RequestUserStore.pickupPerson) {
    //     toast.warn("Please select Pickup Person", { position: "top-center" });
    //     return;
    //   }

    //   if (!RequestUserStore.dropPerson) {
    //     toast.warn("Please select Drop Person", { position: "top-center" });
    //     return;
    //   }

    // }

    reqData.dropPerson = RequestUserStore.dropPerson
      ? RequestUserStore.dropPerson
      : null;
    reqData.pickUpPerson = RequestUserStore.pickupPerson
      ? RequestUserStore.pickupPerson
      : null;

    AssignTechncianToService(reqData);
  };

  const handleChange = (value, option) => {
    setCreateRequestData_({ key: option.name, value: value });
  };

  function isValidTimeValue(value) {
  const date = new Date(value);
  return !isNaN(date.getTime());
}

  return (
    <div>
      <Modal
        closable={{ "aria-label": "Custom Close Button" }}
        open={PageStore?.is_technican_assign_modal}
        maskClosable={false}
        onCancel={closeModal}
        footer={null}
        closeIcon={
          <CloseOutlined
            style={{
              color: "black",
              backgroundColor: "#ffffff",
            }}
          />
        }
      >
        <div className="border rounded-md modal-container ">
          <div className="modal-header">Assign Technician</div>

          <div className="modal-child">
            <span>Name</span>
            <span>{serviceDetail?.bikeRequest?.customerName || ""}</span>
          </div>
          <div className="modal-child">
            <span>Service Type</span>
            <span>
              {serviceDetail?.bikeRequest?.serviceType
                ?.serviceTypeDescription || "-"}
            </span>
          </div>
          <div className="modal-child">
            <span>Service Package</span>
            <span>
              {serviceDetail?.bikeRequest?.packageType?.serviceCategoryName ||
                "------"}
            </span>
          </div>
          <div className="modal-child">
            <span>Slot date</span>
            <span>{serviceDetail?.bikeRequest?.slotBooked?.split("T")[0]}</span>
          </div>

          <div className="modal-child">
            <span>Slot Time</span>
            <span>
              {isValidTimeValue(serviceDetail?.bikeRequest?.slotBooked) ? format(serviceDetail?.bikeRequest?.slotBooked, "hh:mm a"):"Not a valid date"}
            </span>
          </div>

          {CreateRequestDetailsStore?.availableTechnicianData?.superstar &&
            Array.isArray(
              CreateRequestDetailsStore?.availableTechnicianData?.superstar
            ) &&
            (serviceDetail?.bikeRequest?.serviceStatus === "NEW" ||
              serviceDetail?.bikeRequest?.serviceStatus === "ACCEPTED") && (
              <div className="modal-child">
                <span>Technician</span>
                <span>
                  <Select
                    // style={{ width: 200 }}
                    placeholder="Select Bicycle Technician"
                    optionLabelProp="label"
                    className="dropdown-menu"
                    onChange={handleChange}
                  >
                    {CreateRequestDetailsStore?.availableTechnicianData?.superstar?.map(
                      (opt, index) => (
                        <Option
                          key={index}
                          value={opt?.technicianid?._id}
                          label={opt?.technicianid?.name}
                          name="technician"
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: 8,
                            }}
                          >
                            <span>{opt?.technicianid?.name}</span>
                            {/* <img
                              src={opt?.technicianid?.profileUrl}
                              alt={opt?.technicianid?.name}
                              width={30}
                            /> */}
                            <Avatar
                              icon={<UserOutlined />}
                              src={opt?.technicianid?.profileUrl || undefined}
                              onError={() => true}
                            />
                          </div>
                        </Option>
                      )
                    )}
                  </Select>
                </span>
              </div>
            )}

          {CreateRequestDetailsStore?.availableTechnicianData?.pick_drop &&
            Array.isArray(
              CreateRequestDetailsStore?.availableTechnicianData?.pick_drop
            ) &&
            serviceDetail?.bikeRequest?.serviceType?.serviceTypeCode ===
              "PUMB" &&
            !serviceDetail?.bikeRequest?.isStoreArrived && (
              <>
                <div className="modal-child">
                  <span>Pickup person</span>
                  <span>
                    <Select
                      // style={{ width: 200 }}
                      placeholder="Select Pick up person"
                      optionLabelProp="label"
                      className="dropdown-menu"
                      onChange={handleChange}
                    >
                      {CreateRequestDetailsStore?.availableTechnicianData?.pick_drop?.map(
                        (opt, index) => (
                          <Option
                            key={index}
                            value={opt?.technicianid?._id}
                            label={opt?.technicianid?.name}
                            name="pickupPerson"
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 8,
                              }}
                            >
                              <span>{opt?.technicianid?.name}</span>
                              <Avatar
                                icon={<UserOutlined />}
                                src={opt?.technicianid?.profileUrl || undefined}
                                onError={() => true}
                              />
                            </div>
                          </Option>
                        )
                      )}
                    </Select>
                  </span>
                </div>
              </>
            )}

          {CreateRequestDetailsStore?.availableTechnicianData?.pick_drop &&
            Array.isArray(
              CreateRequestDetailsStore?.availableTechnicianData?.pick_drop
            ) &&
            serviceDetail?.bikeRequest?.serviceType?.serviceTypeCode ===
              "PUMB" && (
              <>
                <div className="modal-child">
                  <span>Drop person</span>
                  <span>
                    {" "}
                    <Select
                      // style={{ width: 200 }}
                      placeholder="Select Drop person"
                      optionLabelProp="label"
                      className="dropdown-menu"
                      onChange={handleChange}
                    >
                      {CreateRequestDetailsStore?.availableTechnicianData?.pick_drop?.map(
                        (opt, index) => (
                          <Option
                            key={index}
                            value={opt?.technicianid?._id}
                            label={opt?.technicianid?.name}
                            name="dropPerson"
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 8,
                              }}
                            >
                              <span>{opt?.technicianid?.name}</span>
                              <Avatar
                              icon={<UserOutlined />}
                              src={opt?.technicianid?.profileUrl || undefined}
                              onError={() => true}
                            />
                            </div>
                          </Option>
                        )
                      )}
                    </Select>
                  </span>
                </div>
              </>
            )}

          <div className="submit-btn-container">
            <button className="service-modify-btn" onClick={closeModal}>
              Cancel
            </button>
            <button className="service-modify-btn" onClick={submitHandler}>
              Assign
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AssignTechnicianModal;
